// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__QFOAJ","checkboxInput":"styles_checkboxInput__yFn1Y","checkboxDiv":"styles_checkboxDiv__ngUHh","checkboxText":"styles_checkboxText__46cob"};